(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire9a00"];
var parcelRegister = parcelRequire.register;
parcelRegister("kCaNJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ab96260b76e6cde1$export$2e2bcd8739ae039);

var $5uWxc = parcelRequire("5uWxc");

var $giM8N = parcelRequire("giM8N");

var $9QXJt = parcelRequire("9QXJt");

var $2MgeJ = parcelRequire("2MgeJ");

var $bTBLz = parcelRequire("bTBLz");

var $6EvfL = parcelRequire("6EvfL");

var $8WgU0 = parcelRequire("8WgU0");

var $9msyL = parcelRequire("9msyL");

var $28FCd = parcelRequire("28FCd");

var $7z3Sn = parcelRequire("7z3Sn");

var $epZoF = parcelRequire("epZoF");

var $kKAXX = parcelRequire("kKAXX");

var $i2xP1 = parcelRequire("i2xP1");

var $2nKsZ = parcelRequire("2nKsZ");

var $7gxrj = parcelRequire("7gxrj");

var $ahcAq = parcelRequire("ahcAq");

var $fy0H4 = parcelRequire("fy0H4");

const $ab96260b76e6cde1$var$_Game = ()=>{
    const { id: id } = (0, $bTBLz.useParams)();
    const game = (0, $ahcAq.useFetchAndSubscribe)({
        url: `${(0, $epZoF.Urls).ApiRestOteGameBaseUrl}/${id}`,
        key: "ote_game"
    });
    const homeGameTeam = game?.ote_games_ote_teams.find((t)=>t.is_home_team);
    const awayGameTeam = game?.ote_games_ote_teams.find((t)=>!t.is_home_team);
    const homeTeam = homeGameTeam?.ote_team;
    const awayTeam = awayGameTeam?.ote_team;
    // We can't conditionally apply the hook so instead pass empty data during fetch
    (0, $7gxrj.useSetDocumentState)(game ? {
        title: `${awayTeam?.name ?? "TBD"} @ ${homeTeam?.name ?? "TBD"} - OTE Play-By-Play`,
        description: game.status === "confirmed" || game.status === "finished" ? `The ${awayTeam.name} played the ${homeTeam.name} on ${(0, $fy0H4.getEstDateTime)(game.starts_at).toLocaleString({
            day: "numeric",
            month: "long",
            year: "numeric"
        })} in ${game.city}, ${game.state}. The ${homeGameTeam.points > awayGameTeam.points ? homeTeam.name : awayTeam.name} won ${Math.max(homeGameTeam.points, awayGameTeam.points)} to ${Math.min(homeGameTeam.points, awayGameTeam.points)}.` : undefined
    } : {});
    const data = {
        "@context": "https://schema.org",
        "@type": "SportsEvent",
        name: game?.competition_name,
        homeTeam: homeTeam ? {
            "@type": "SportsTeam",
            name: homeTeam.name,
            url: `https://overtimeelite.com/teams/${homeTeam.slug}`
        } : undefined,
        awayTeam: awayTeam ? {
            "@type": "SportsTeam",
            name: awayTeam.name,
            url: `https://overtimeelite.com/teams/${awayTeam.slug}`
        } : undefined,
        startDate: game?.starts_at,
        endDate: (0, $9QXJt.DateTime).fromISO(game?.starts_at).plus({
            hour: 1.5
        }).toISO(),
        location: {
            "@type": "Place",
            name: game?.location_name ?? (game?.address?.startsWith("230 17th") ? "OTE Arena" : undefined),
            address: {
                "@type": "PostalAddress",
                streetAddress: game?.address,
                addressLocality: game?.city,
                addressRegion: game?.state,
                postalCode: game?.zip
            },
            latitude: game?.latitude,
            longitude: game?.longitude
        },
        offers: game?.ote_event?.vivenu_id ? {
            "@type": "Offer",
            url: `https://tickets.overtimeelite.com/event/${game?.ote_event?.vivenu_id}`
        } : undefined,
        eventAttendanceMode: game?.expected_broadcast ? "MixedEventAttendanceMode" : "OfflineEventAttendanceMode",
        organizer: {
            "@type": "SportsOrganization",
            name: "Overtime Elite",
            url: "https://overtimeelite.com"
        },
        sport: "Basketball"
    };
    const ote_games_ote_players_ote_teams = (0, $ahcAq.useFetchAndSubscribe)({
        url: `${(0, $epZoF.Urls).ApiRestOteGameBaseUrl}/${id}/ote_games_ote_players_ote_teams`,
        key: "ote_games_ote_players_ote_teams"
    });
    if (!game) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $i2xP1.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "GameHeader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $8WgU0.default), {
        ote_game: game,
        linkToGamePage: false
    }), !(0, $kKAXX.isComplete)(game) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "ViewingDetailsContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: `LocationInfo CenterContent`
    }, game.address ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        className: "Location",
        href: `https://www.google.com/maps/place/${game.address},${game.city},${game.state}+${game.zip}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $5uWxc.faMapLocation)
    }), game.address?.replace(", USA", "")) : null)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $6EvfL.default), {
        game: game,
        players: ote_games_ote_players_ote_teams ?? [],
        awayGameTeam: awayGameTeam,
        homeGameTeam: homeGameTeam
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(data)
        }
    }));
};
const $ab96260b76e6cde1$var$Game = ()=>{
    const { id: id } = (0, $bTBLz.useParams)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $9msyL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Game"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $7z3Sn.default), null, "Box Score"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $28FCd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $2nKsZ.default), {
        id: id,
        redirectPrefix: "/games"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($ab96260b76e6cde1$var$_Game, null)))));
};
var $ab96260b76e6cde1$export$2e2bcd8739ae039 = $ab96260b76e6cde1$var$Game;

});
parcelRegister("6EvfL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d1f4eca2feed4fb$export$2e2bcd8739ae039);

var $2MgeJ = parcelRequire("2MgeJ");

var $bTBLz = parcelRequire("bTBLz");

var $28FCd = parcelRequire("28FCd");

var $gMp4q = parcelRequire("gMp4q");

var $epZoF = parcelRequire("epZoF");

var $kKAXX = parcelRequire("kKAXX");

var $ahcAq = parcelRequire("ahcAq");

var $fgN6a = parcelRequire("fgN6a");

var $4tHic = parcelRequire("4tHic");

var $7uFn1 = parcelRequire("7uFn1");


var $hVd8l = parcelRequire("hVd8l");
const $2d1f4eca2feed4fb$var$Tabs = ({ game: game, players: players, homeGameTeam: homeGameTeam, awayGameTeam: awayGameTeam })=>{
    const { section: section } = (0, $bTBLz.useParams)();
    const homeTeam = homeGameTeam?.ote_team;
    const awayTeam = awayGameTeam?.ote_team;
    // Check if YouTube video is ready and available to the public
    let youTubeVideo = null;
    if (game.youtube_id) {
        const fetchResult = (0, $ahcAq.default)({
            url: `${(0, $epZoF.Urls).ApiPlatformsYouTubeVideosUrl}/${game.youtube_id}`
        });
        youTubeVideo = fetchResult.result.read();
    }
    const tabs = [
        youTubeVideo?.snippet ? {
            name: "video",
            text: (0, $kKAXX.isLive)(game) ? "Live" : "Watch",
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $hVd8l.default), {
                youTubeVideo: youTubeVideo
            })
        } : null,
        !game.is_stats_hidden ? {
            name: "box_score",
            text: "Box Score",
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $fgN6a.default), {
                game: game,
                players: players,
                awayGameTeam: awayGameTeam,
                homeGameTeam: homeGameTeam
            })
        } : null,
        !game.is_stats_hidden ? {
            name: "away",
            text: awayTeam?.name,
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $7uFn1.default), {
                players: players,
                ote_game: game,
                gameTeam: awayGameTeam,
                teamId: awayGameTeam?.ote_team_id
            })
        } : null,
        !game.is_stats_hidden ? {
            name: "home",
            text: homeTeam?.name,
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $7uFn1.default), {
                players: players,
                ote_game: game,
                gameTeam: homeGameTeam,
                teamId: homeGameTeam?.ote_team_id
            })
        } : null,
        !game.is_stats_hidden ? (0, $kKAXX.isLive)(game) || (0, $kKAXX.isComplete)(game) ? {
            name: "play_by_play",
            text: "Play By Play",
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $4tHic.default), {
                ote_game: game,
                awayGameTeam: awayGameTeam,
                homeGameTeam: homeGameTeam
            })
        } : null : null
    ].filter(Boolean);
    const defaultTab = section ? section : tabs[0]?.name;
    const [tabIndex, setTabIndex] = (0, $2MgeJ.useState)(tabs.findIndex((t)=>t.name === defaultTab));
    const [tab, setTab] = (0, $2MgeJ.useState)(defaultTab);
    (0, $2MgeJ.useEffect)(()=>{
        let index = tabs.map((t)=>t.name).indexOf(tab);
        setTabIndex(index === -1 ? 0 : index);
    }, [
        tab
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "GameTabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TabBar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TabContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $gMp4q.default), {
        links: tabs.map((t)=>[
                t.name,
                t.text
            ]),
        section: tab,
        useCallback: (t)=>setTab(t),
        root: `/games/${game.id}`,
        useHistoryState: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TabContent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TransitionContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "ContentGrid",
        style: {
            left: `${-100 * tabIndex}%`,
            gridTemplateColumns: "100%".repeat(tabs.length)
        }
    }, tabs.map((t)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            key: t.name,
            style: {
                maxHeight: tab === t.name ? null : 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $28FCd.default), {
            errorComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null)
        }, t.component));
    })))));
};
var $2d1f4eca2feed4fb$export$2e2bcd8739ae039 = $2d1f4eca2feed4fb$var$Tabs;

});
parcelRegister("fgN6a", function(module, exports) {

$parcel$export(module.exports, "default", () => $061cd55135e3b759$export$2e2bcd8739ae039);

var $2MgeJ = parcelRequire("2MgeJ");


var $dyqPK = parcelRequire("dyqPK");

var $73HaT = parcelRequire("73HaT");

var $2XFWP = parcelRequire("2XFWP");
const $061cd55135e3b759$var$BoxScore = ({ game: game, players: players, awayGameTeam: awayGameTeam, homeGameTeam: homeGameTeam })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "GameBoxScore"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: `PeriodsContainer`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $dyqPK.default), {
        game: game,
        homeTeam: homeGameTeam,
        awayTeam: awayGameTeam
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $73HaT.default), {
        game: game,
        players: players,
        homeGameTeam: homeGameTeam,
        awayGameTeam: awayGameTeam
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $2XFWP.default), {
        game: game,
        homeGameTeam: homeGameTeam,
        awayGameTeam: awayGameTeam
    })));
};
var $061cd55135e3b759$export$2e2bcd8739ae039 = $061cd55135e3b759$var$BoxScore;

});
parcelRegister("dyqPK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd06afc1d7e30e32$export$2e2bcd8739ae039);

var $2MgeJ = parcelRequire("2MgeJ");

var $AIdML = parcelRequire("AIdML");

var $7gWUw = parcelRequire("7gWUw");

var $i8zrc = parcelRequire("i8zrc");

const $cd06afc1d7e30e32$var$TeamLogo = ({ ote_game: ote_game, ote_team: ote_team })=>{
    const [themeTeam, setThemeTeam] = (0, $2MgeJ.useState)((0, $i8zrc.getThemeTeam)(ote_team?.id, ote_game.theme_name));
    const [logoPath, setLogoPath] = (0, $2MgeJ.useState)(themeTeam ? `https://images.overtime.tv/${themeTeam.logo_path}` : ote_team?.small_logo_path ? `https://images.overtime.tv/${ote_team?.small_logo_path}?width=80&format=webp` : ote_team?.logo_path ? `https://images.overtime.tv/${ote_team?.logo_path}?width=80&format=webp` : `${0, $7gWUw.imgOteLogoWhiteSvg}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: ote_team ? `/teams/${ote_team?.slug}` : undefined,
        className: "TeamLogo",
        style: {
            backgroundImage: `url(${logoPath})`
        }
    }, !ote_team?.small_logo_path && !ote_team?.logo_path ? ote_team?.team_code?.[0] : null);
};
const $cd06afc1d7e30e32$var$Row = ({ ote_game: ote_game, ote_game_ote_team: ote_game_ote_team })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("th", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($cd06afc1d7e30e32$var$TeamLogo, {
        ote_game: ote_game,
        ote_team: ote_game_ote_team?.ote_team
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        className: "desktop-only",
        href: ote_game_ote_team?.ote_team ? `/teams/${ote_game_ote_team?.ote_team?.slug}` : undefined
    }, ote_game_ote_team?.ote_team?.name ?? "-"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        className: "mobile-only",
        href: ote_game_ote_team?.ote_team ? `/teams/${ote_game_ote_team?.ote_team?.slug}` : undefined
    }, ote_game_ote_team?.ote_team?.team_code ?? "-")), [
        1,
        2,
        3,
        4
    ].map((period)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("td", {
            key: period
        }, ote_game_ote_team?.ote_game_ote_team_periods?.find((p)=>p.period_id === period)?.points ?? 0)), [
        11,
        12,
        13,
        14,
        15
    ].map((period)=>ote_game_ote_team?.ote_game_ote_team_periods?.find((p)=>p.period_id === period) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("td", {
            key: period
        }, ote_game_ote_team?.ote_game_ote_team_periods?.find((p)=>p.period_id === period)?.points ?? 0) : null).filter(Boolean), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("td", {
        className: "Total"
    }, ote_game_ote_team?.points ?? 0));
const $cd06afc1d7e30e32$var$Periods = ({ game: game, homeTeam: homeTeam, awayTeam: awayTeam })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "GamePeriods"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $AIdML.default), {
        headers: [
            ...[
                "Q1",
                "Q2",
                "Q3",
                "Q4"
            ].map((p)=>({
                    label: p,
                    mobileLabel: p.replace("Q", "")
                })),
            ...[
                11,
                12,
                13,
                14,
                15
            ].map((ot)=>homeTeam?.ote_game_ote_team_periods?.find((p)=>p.period_id === ot) ? {
                    label: `OT${ot > 11 ? ot - 10 : ""}`
                } : null).filter(Boolean),
            {
                label: "Total",
                mobileLabel: "T"
            }
        ],
        currentHeader: "",
        rows: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($cd06afc1d7e30e32$var$Row, {
                key: "away",
                ote_game: game,
                ote_game_ote_team: awayTeam
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($cd06afc1d7e30e32$var$Row, {
                key: "home",
                ote_game: game,
                ote_game_ote_team: homeTeam
            })
        ]
    }));
};
var $cd06afc1d7e30e32$export$2e2bcd8739ae039 = $cd06afc1d7e30e32$var$Periods;

});

parcelRegister("73HaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $89279bbac91bbd8e$export$2e2bcd8739ae039);

var $275Aj = parcelRequire("275Aj");

var $2MgeJ = parcelRequire("2MgeJ");

var $fy0H4 = parcelRequire("fy0H4");

var $7gWUw = parcelRequire("7gWUw");

var $i8zrc = parcelRequire("i8zrc");

const $89279bbac91bbd8e$var$getInitial = (first_name, last_name)=>{
    if (last_name === "Thompson" && (first_name === "Amen" || first_name === "Ausar")) return `${first_name.substring(0, 2)}. ${last_name}`;
    return `${first_name[0]}. ${last_name}`;
};
const $89279bbac91bbd8e$var$TeamLogo = ({ ote_team: ote_team, ote_game: ote_game })=>{
    const [themeTeam, setThemeTeam] = (0, $2MgeJ.useState)((0, $i8zrc.getThemeTeam)(ote_team?.id, ote_game.theme_name));
    const [logoPath, setLogoPath] = (0, $2MgeJ.useState)(themeTeam ? `https://images.overtime.tv/${themeTeam.logo_path}` : ote_team?.small_logo_path ? `https://images.overtime.tv/${ote_team?.small_logo_path}?width=80&format=webp` : ote_team?.logo_path ? `https://images.overtime.tv/${ote_team?.logo_path}?width=80&format=webp` : `${0, $7gWUw.imgOteLogoWhiteSvg}`);
    const [primaryColor, setPrimaryColor] = (0, $2MgeJ.useState)(themeTeam ? themeTeam.primary_color : ote_team?.primary_color);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TeamLogo",
        style: {
            backgroundColor: (0, $fy0H4.colorFromInt)(primaryColor),
            backgroundImage: `url(${logoPath})`
        }
    }, !ote_team?.small_logo_path && !ote_team?.logo_path ? ote_team?.team_code?.[0] : null);
};
const $89279bbac91bbd8e$var$PlayerProfile = ({ game: game, player: player, team: team, stat: stat })=>{
    const player_profile_url = player?.is_current && player?.is_ote && team.is_current ? `/players/${player.id}` : null;
    const [themeTeam, setThemeTeam] = (0, $2MgeJ.useState)((0, $i8zrc.getThemeTeam)(team?.id, game.theme_name));
    const [primaryColor, setPrimaryColor] = (0, $2MgeJ.useState)(themeTeam ? themeTeam.primary_color : team?.primary_color);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Profile"
    }, player?.image_path ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: player_profile_url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        alt: player.full_name,
        style: {
            backgroundColor: (0, $fy0H4.colorFromInt)(primaryColor)
        },
        src: `https://images.overtime.tv/${player.image_path}?format=webp&width=160`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($89279bbac91bbd8e$var$TeamLogo, {
        ote_game: game,
        ote_team: team
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Name"
    }, player ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        className: "mobile-only",
        href: player_profile_url
    }, $89279bbac91bbd8e$var$getInitial(player.first_name, player.family_name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        className: "desktop-only",
        href: player_profile_url
    }, player.first_name, " ", player.family_name)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Position"
    }, player?.position ? `${player.position} / ` : "", team.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Stat"
    }, stat));
};
const $89279bbac91bbd8e$var$_TeamLeaders = ({ game: game, stats: stats, gameTeam: gameTeam, players: players })=>{
    const teamPlayers = players.filter(Boolean).filter((p)=>p?.ote_team_id === gameTeam?.ote_team_id && p.ote_game_id === gameTeam?.ote_game_id);
    const topPlayers = stats.map((s)=>{
        // sort all players from lowest to highest in the stat then pop the last one (highest stat) off to be stored in "statLeader"
        const statLeader = (0, $275Aj.sortBy)(teamPlayers, [
            (p)=>(0, (/*@__PURE__*/$parcel$interopDefault($275Aj))).isNil(p[s[0]]) ? 0 : p[s[0]],
            (p)=>(0, (/*@__PURE__*/$parcel$interopDefault($275Aj))).isNil(p.plus_minus) ? -Infinity : p.plus_minus
        ]).pop();
        if (!statLeader) return {
            stat: s[1],
            value: null,
            player: null
        };
        return {
            stat: s[1],
            value: statLeader[s[0]],
            player: statLeader
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Team"
    }, topPlayers.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "Player",
            key: p.stat
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($89279bbac91bbd8e$var$PlayerProfile, {
            game: game,
            player: p.value > 0 ? p.player.ote_player : null,
            team: gameTeam.ote_team,
            stat: `${p.value > 0 ? p.value : "\u2013"} ${p.stat}`
        }))));
};
const $89279bbac91bbd8e$var$TeamLeaders = ({ game: game, players: players, awayGameTeam: awayGameTeam, homeGameTeam: homeGameTeam })=>{
    const stats = [
        [
            "points",
            "pts"
        ],
        [
            "rebounds_total",
            "reb"
        ],
        [
            "assists",
            "ast"
        ]
    ];
    return awayGameTeam?.ote_team_id && homeGameTeam?.ote_team_id && players?.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "GameTeamLeaders"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h2", null, "Team Leaders"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "LeadersContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($89279bbac91bbd8e$var$_TeamLeaders, {
        game: game,
        stats: stats,
        players: players,
        gameTeam: awayGameTeam
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "StatNames"
    }, stats.map((s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            key: s[0]
        }, s[1]))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($89279bbac91bbd8e$var$_TeamLeaders, {
        game: game,
        stats: stats,
        players: players,
        gameTeam: homeGameTeam
    }))) : null;
};
var $89279bbac91bbd8e$export$2e2bcd8739ae039 = $89279bbac91bbd8e$var$TeamLeaders;

});

parcelRegister("2XFWP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ab3a63aaca76be3$export$2e2bcd8739ae039);

var $2MgeJ = parcelRequire("2MgeJ");

var $fy0H4 = parcelRequire("fy0H4");

var $7gWUw = parcelRequire("7gWUw");

var $i8zrc = parcelRequire("i8zrc");

const $0ab3a63aaca76be3$var$TeamLogo = ({ ote_team: ote_team, ote_game: ote_game })=>{
    const [themeTeam, setThemeTeam] = (0, $2MgeJ.useState)((0, $i8zrc.getThemeTeam)(ote_team?.id, ote_game.theme_name));
    const [logoPath, setLogoPath] = (0, $2MgeJ.useState)(themeTeam ? `https://images.overtime.tv/${themeTeam.logo_path}` : ote_team?.small_logo_path ? `https://images.overtime.tv/${ote_team?.small_logo_path}?width=80&format=webp` : ote_team?.logo_path ? `https://images.overtime.tv/${ote_team?.logo_path}?width=80&format=webp` : `${0, $7gWUw.imgOteLogoWhiteSvg}`);
    const [primaryColor, setPrimaryColor] = (0, $2MgeJ.useState)(themeTeam ? themeTeam.primary_color : ote_team?.primary_color);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: ote_team ? `/teams/${ote_team?.slug}` : undefined,
        className: "TeamLogo",
        style: {
            backgroundColor: (0, $fy0H4.colorFromInt)(primaryColor),
            backgroundImage: `url(${logoPath})`
        }
    }, !ote_team?.small_logo_path && !ote_team?.logo_path ? ote_team?.team_code?.[0] : null);
};
const $0ab3a63aaca76be3$var$TeamStats = ({ game: game, awayGameTeam: awayGameTeam, homeGameTeam: homeGameTeam })=>{
    if (!awayGameTeam || !homeGameTeam) return null;
    const [themeTeamHome, setThemeTeamHome] = (0, $2MgeJ.useState)((0, $i8zrc.getThemeTeam)(homeGameTeam?.ote_team_id, game.theme_name));
    const [themeTeamAway, setThemeTeamAway] = (0, $2MgeJ.useState)((0, $i8zrc.getThemeTeam)(awayGameTeam?.ote_team_id, game.theme_name));
    const [homeTeamPrimaryColor, setHomeTeamPrimaryColor] = (0, $2MgeJ.useState)(themeTeamHome ? themeTeamHome.primary_color : homeGameTeam?.ote_team.primary_color);
    const [awayTeamPrimaryColor, setAwayTeamPrimaryColor] = (0, $2MgeJ.useState)(themeTeamAway ? themeTeamAway.primary_color : awayGameTeam?.ote_team.primary_color);
    const statNames = [
        [
            "points",
            "pts"
        ],
        [
            "rebounds_total",
            "reb"
        ],
        [
            "assists",
            "ast"
        ],
        [
            "steals",
            "stl"
        ],
        [
            "blocks",
            "blk"
        ],
        [
            "turnovers",
            "to"
        ]
    ];
    const stats = statNames.map((s)=>{
        const maxValue = Math.max(awayGameTeam[s[0]] ?? 0, homeGameTeam[s[0]] ?? 0);
        return {
            name: s[0],
            key: s[1],
            awayValue: awayGameTeam[s[0]] ?? 0,
            homeValue: homeGameTeam[s[0]] ?? 0,
            awayRatio: maxValue > 0 ? awayGameTeam[s[0]] / maxValue * 100 : 0,
            homeRatio: maxValue > 0 ? homeGameTeam[s[0]] / maxValue * 100 : 0
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "GameTeamStats"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h2", null, "Team Stats"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TeamLogosContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($0ab3a63aaca76be3$var$TeamLogo, {
        ote_game: game,
        ote_team: awayGameTeam.ote_team
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($0ab3a63aaca76be3$var$TeamLogo, {
        ote_game: game,
        ote_team: homeGameTeam.ote_team
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "StatsContainer"
    }, stats.map((s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "Stat",
            key: s.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "AwayTeam"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, s.awayValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "Chart",
            "aria-label": `${awayGameTeam.ote_team.name} ${s.name}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "Bar",
            style: {
                width: `${s.awayRatio}%`,
                backgroundColor: (0, $fy0H4.colorFromInt)(awayTeamPrimaryColor)
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "Name"
        }, s.key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "HomeTeam"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, s.homeValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "Chart",
            "aria-label": `${homeGameTeam.ote_team.name} ${s.name}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "Bar",
            style: {
                width: `${s.homeRatio}%`,
                backgroundColor: (0, $fy0H4.colorFromInt)(homeTeamPrimaryColor)
            }
        })))))));
};
var $0ab3a63aaca76be3$export$2e2bcd8739ae039 = $0ab3a63aaca76be3$var$TeamStats;

});


parcelRegister("4tHic", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7674a87331e5302$export$2e2bcd8739ae039);

var $275Aj = parcelRequire("275Aj");

var $2MgeJ = parcelRequire("2MgeJ");

var $bTBLz = parcelRequire("bTBLz");

var $fElq7 = parcelRequire("fElq7");

var $cSbFE = parcelRequire("cSbFE");

var $epZoF = parcelRequire("epZoF");

var $ahcAq = parcelRequire("ahcAq");

var $fy0H4 = parcelRequire("fy0H4");

const $b7674a87331e5302$export$ada873a34909da65 = ({ ote_game: ote_game, awayGameTeam: awayGameTeam, homeGameTeam: homeGameTeam })=>{
    const { id: id } = (0, $bTBLz.useParams)();
    const [moreEvents, setMoreEvents] = (0, $2MgeJ.useState)([]);
    const ote_game_events = (0, $ahcAq.useFetchAndSubscribe)({
        url: `${(0, $epZoF.Urls).ApiRestOteGameBaseUrl}/${id}/ote_game_events?limit=20`,
        key: "ote_game_events"
    }) ?? [];
    const gameEvents = (0, $275Aj.sortBy)((0, $275Aj.uniqBy)([
        ...ote_game_events,
        ...moreEvents
    ].filter((e)=>e?.ote_game_id === ote_game.id && ![
            "clockAdjustment",
            "fixture",
            "possession",
            "possessionArrow",
            "scoreAdjustment",
            "statusAdjustment",
            "main"
        ].includes(e?.event_type?.toLowerCase()) && ![
            "confirmed",
            "pending"
        ].includes(e?.sub_type?.toLowerCase())), "id"), [
        "event_time",
        "created_at",
        "id"
    ]).reverse();
    const homeTeam = homeGameTeam?.ote_team;
    const awayTeam = awayGameTeam?.ote_team;
    const [isFetchingMore, setIsFetchingMore] = (0, $2MgeJ.useState)(false);
    const [isNoMoreEvents, setIsNoMoreEvents] = (0, $2MgeJ.useState)(false);
    const getMoreEvents = ()=>{
        if (isFetchingMore) return;
        const fetchEvents = async ()=>{
            setIsFetchingMore(true);
            try {
                const lastEvent = (0, $275Aj.minBy)([
                    ...ote_game_events,
                    ...moreEvents
                ], "event_time");
                const { ote_game_events: newEvents } = await (await fetch(`${(0, $epZoF.Urls).ApiRestOteGameBaseUrl}/${id}/ote_game_events?limit=50&event_time_before=${lastEvent.event_time}`)).json();
                if (newEvents.length === 0 || newEvents.length === 1 && newEvents[0].id === lastEvent.id) setIsNoMoreEvents(true);
                else setMoreEvents((e)=>(0, $275Aj.uniqBy)([
                        ...e,
                        ...newEvents
                    ], "id"));
            } catch (error) {
                console.error(error);
            }
            setIsFetchingMore(false);
        };
        fetchEvents();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "GameEvents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        id: "EventsTable",
        className: "EventsContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("th", {
        style: {
            textAlign: "center"
        }
    }, "Time"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("th", {
        style: {
            width: "2em"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("th", {
        style: {
            width: "5em"
        }
    }, "Play"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("th", {
        className: "PbpTeam"
    }, awayTeam?.team_code ?? ""), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("th", {
        className: "PbpTeam"
    }, homeTeam?.team_code ?? ""))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("tbody", null, gameEvents.map((ge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("tr", {
            key: ge.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("td", {
            className: "Time"
        }, $b7674a87331e5302$var$formatClock(ge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("td", {
            className: "TeamLogo"
        }, ge.ote_team?.logo_path ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
            src: `https://images.overtime.tv/${ge.ote_team.logo_path}?width=50&format=webp`,
            alt: ge.ote_team.name
        }) : ge.ote_team?.team_code), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("span", {
            className: "Name"
        }, ge.ote_player ? ge.ote_player?.full_name : ge.ote_team?.name), " ", (0, $fy0H4.capitalize)($b7674a87331e5302$var$formatWords(ge.event_type)), " ", $b7674a87331e5302$var$formatWords(ge.event_type) === "Period" ? ge.period_id : "", " ", $b7674a87331e5302$var$formatWords(ge.sub_type) ?? "", " ", ge.success === true ? "made" : ge.success === false ? "missed" : "")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("td", {
            className: "PbpScore"
        }, ge.ote_game_event_scores?.find((s)=>s.ote_team_id == awayTeam.id)?.score), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("td", {
            className: "PbpScore"
        }, ge.ote_game_event_scores?.find((s)=>s.ote_team_id == homeTeam.id)?.score))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "FetchMoreContainer"
    }, isFetchingMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $cSbFE.default), null) : !isNoMoreEvents ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $fElq7.default), {
        onClick: getMoreEvents
    }, "More") : null));
};
const $b7674a87331e5302$var$formatClock = (ge)=>{
    const clock = `${Math.floor(ge.clock / 1000 / 60)}:${String(ge.clock / 1000 % 60).padStart(2, "0")}`;
    return clock;
};
const $b7674a87331e5302$var$formatWords = (word)=>{
    if (!word) return;
    const words = word?.match(/[0-9a-zA-Z][a-z]*/g);
    if (words[0] === "1" && words[1] === "0") return "10 second";
    if (words[0] === "main") return "Clock";
    if (words[0] === "3" && words[1] === "sec") return "3 second";
    if (words[0] === "jump" && words[1] === "Ball") return "Jump ball";
    switch(words[0]){
        case "5":
            return "5 second";
        case "8":
            return "8 second";
        case "period":
            return [
                (0, $fy0H4.capitalize)(words[0]),
                ...words.slice(1)
            ].join();
        case "time":
            return [
                (0, $fy0H4.capitalize)(words[0]) + " out"
            ].join();
        default:
            return words.map((w)=>w.toLowerCase()).join(" ");
    }
};
var $b7674a87331e5302$export$2e2bcd8739ae039 = $b7674a87331e5302$export$ada873a34909da65;

});

parcelRegister("7uFn1", function(module, exports) {

$parcel$export(module.exports, "default", () => $443794a148a7647c$export$2e2bcd8739ae039);

var $275Aj = parcelRequire("275Aj");

var $2MgeJ = parcelRequire("2MgeJ");

var $5wMv4 = parcelRequire("5wMv4");

var $28FCd = parcelRequire("28FCd");

var $epZoF = parcelRequire("epZoF");

var $ahcAq = parcelRequire("ahcAq");

const $443794a148a7647c$var$_Players = ({ game: game, gameTeam: gameTeam, teamId: teamId, players: players })=>{
    const team = (0, $ahcAq.useFetchAndSubscribe)({
        url: `${(0, $epZoF.Urls).ApiRestOteTeamsUrl}/${teamId}`,
        key: "ote_team"
    });
    const stubPlayers = (0, $275Aj.keyBy)(team?.ote_players.map((ote_player)=>({
            id: ote_player.id,
            created_at: ote_player.created_at,
            updated_at: ote_player.updated_at,
            ote_player_id: ote_player.id,
            ote_player: ote_player,
            ote_team_id: team.id,
            ote_game_id: game.id
        })), "id");
    const initialGamePlayers = (0, $275Aj.keyBy)(players?.filter(Boolean).filter((p)=>p?.ote_team_id === teamId && p.ote_game_id === game.id), "ote_player_id");
    const gamePlayers = {
        ...stubPlayers,
        ...initialGamePlayers
    };
    const filteredPlayers = (0, $275Aj.sortBy)((0, $275Aj.uniqBy)([
        ...team?.ote_players ?? [],
        ...Object.values(gamePlayers).map((g)=>g.ote_player)
    ].filter((p)=>[
            "finished",
            "confirmed"
        ].includes(game.status) ? gamePlayers[p?.id]?.minutes > 0 : true), "id"), [
        "family_name",
        "first_name"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5wMv4.default), {
        rows: [
            ...filteredPlayers.map((p)=>({
                    ...gamePlayers[p?.id],
                    ote_player: {
                        ...p,
                        ote_team: team
                    },
                    ...p
                })),
            gameTeam
        ],
        isTakeover: game.game_category === "Takeover",
        title: "Player",
        collapsableRowHeader: true,
        showStatRank: false,
        defaultHeader: "minutes"
    });
};
const $443794a148a7647c$var$Players = ({ ote_game: ote_game, gameTeam: gameTeam, teamId: teamId, players: players })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "GamePlayers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $28FCd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($443794a148a7647c$var$_Players, {
        players: players,
        game: ote_game,
        gameTeam: gameTeam,
        teamId: teamId
    })));
};
var $443794a148a7647c$export$2e2bcd8739ae039 = $443794a148a7647c$var$Players;

});

parcelRegister("hVd8l", function(module, exports) {

$parcel$export(module.exports, "default", () => $beb54be837e32d2c$export$2e2bcd8739ae039);

var $2MgeJ = parcelRequire("2MgeJ");

var $7gWUw = parcelRequire("7gWUw");

var $ki0Ss = parcelRequire("ki0Ss");

const $beb54be837e32d2c$var$Video = ({ youTubeVideo: youTubeVideo })=>{
    if (!youTubeVideo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null);
    const imagePath = Object.values(youTubeVideo.snippet.thumbnails).reduce((best, t)=>t.width > best.width ? t : best, {
        width: 0
    }).url;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "GameVideo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: `https://www.youtube.com/v/${youTubeVideo.id}`,
        title: youTubeVideo.snippet.title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $ki0Ss.default), {
        src: `https://images.itsovertime.com/youtube${new URL(imagePath).pathname}`,
        alt: youTubeVideo.snippet.title,
        mobileWidth: 640
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        className: "Play",
        alt: "Play Video",
        src: (0, $7gWUw.imgPlaySvg)
    })));
};
var $beb54be837e32d2c$export$2e2bcd8739ae039 = $beb54be837e32d2c$var$Video;

});


parcelRegister("2nKsZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1312dd9ac5d61a2a$export$2e2bcd8739ae039);

var $5RGWv = parcelRequire("5RGWv");

var $275Aj = parcelRequire("275Aj");
parcelRequire("2MgeJ");

var $gEIs8 = parcelRequire("gEIs8");

var $i2xP1 = parcelRequire("i2xP1");
var $1312dd9ac5d61a2a$export$2e2bcd8739ae039 = ({ id: id, redirectPrefix: redirectPrefix, children: children })=>{
    if (redirectPrefix.endsWith("/")) console.warn("Don't include trailing slash in redirectPrefix");
    if (!(0, $gEIs8.default)(id)) {
        const fixedId = id.slice(0, id.match(/[^a-f0-9\-]/)?.index);
        if (typeof window !== "undefined" && fixedId !== id && !(0, $275Aj.isEmpty)(fixedId)) {
            location.href = `${redirectPrefix}/${fixedId}`;
            return;
        } else return /*#__PURE__*/ (0, $5RGWv.jsx)((0, $i2xP1.default), {});
    }
    return children;
};

});
parcelRegister("gEIs8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c202dd2ea31b7d5e$export$2e2bcd8739ae039);

var $l2KrZ = parcelRequire("l2KrZ");
function $c202dd2ea31b7d5e$var$validate(uuid) {
    return typeof uuid === "string" && (0, $l2KrZ.default).test(uuid);
}
var $c202dd2ea31b7d5e$export$2e2bcd8739ae039 = $c202dd2ea31b7d5e$var$validate;

});
parcelRegister("l2KrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f51dd0f5ccbfc5f0$export$2e2bcd8739ae039);
var $f51dd0f5ccbfc5f0$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




})();
//# sourceMappingURL=Game.409c5c2f.js.map
